import { useEffect, useRef, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Users, Send, Loader2 } from "lucide-react";

export function MentorRoom() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const scrollRef = useRef(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/mentor/room"); setMsgs(data || []); } catch { /* ignore */ }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, [load]);
  useEffect(() => { scrollRef.current?.scrollTo(0, scrollRef.current.scrollHeight); }, [msgs]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { await api.post("/admin/mentor/room", { text: text.trim() }); setText(""); await load(); }
    catch { /* ignore */ }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl" data-testid="mentor-room">
      <div className="flex items-center gap-2 mb-3"><Users className="h-4 w-4 text-[#1C8CFF]" />
        <span className="font-heading font-semibold">Mentor Room</span>
        <span className="font-mono-term text-[11px] text-[#666]">— chat prive (CEO + Mentor sèlman)</span></div>
      <div className="border border-[#222] bg-[#0F0F0F] flex flex-col h-[460px]">
        <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-3" data-testid="mentor-room-messages">
          {msgs.length === 0 ? <div className="text-center text-[#888] text-sm mt-10">Kòmanse kowòdone ak lòt mentor yo isit la.</div> :
            msgs.map((m) => {
              const mine = m.name === (user?.name || user?.email);
              return (
                <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[75%] rounded-2xl px-3.5 py-2 ${mine ? "bg-[#1C8CFF] text-white" : "bg-[#161616] text-[#eee]"}`}>
                    <div className="text-[10px] font-mono-term uppercase opacity-70 mb-0.5">{m.name} · {m.role}</div>
                    <div className="text-sm whitespace-pre-wrap">{m.text}</div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="border-t border-[#222] p-3 flex items-center gap-2">
          <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
            data-testid="mentor-room-input" placeholder="Ekri yon mesaj..." className="bg-[#0A0A0A] border-[#222] rounded-sm h-11" />
          <Button onClick={send} disabled={busy} data-testid="mentor-room-send"
            className="h-11 rounded-sm bg-white text-black hover:bg-[#e5e5e5] px-4">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          </Button>
        </div>
      </div>
    </div>
  );
}
